
<template>
    <div class="pp-folder">
        <slot></slot>
    </div>
</template>

<script>
/**
 * 折叠面板
 * @desc 接受v-model，配合<pp-folder-item>使用
 * @param {[Array, string]} value 展开面板的name，<Array>同时可展开多项 <string>同时最多展开一项(accordion模式)
 * @param {boolean} accordioin 手风琴折叠模式，同时只展开一个面板
 */
    export default {
        name: 'pp-folder',
        props: {
            accordion: Boolean,
            value: [String, Array],
            withIcon: Boolean,
        },
        methods: {
            update: function(val) {
                if(this.accordion) {
                    this.$emit('input', val == this.value ? '' : val)
                }
                else {
                    let isExsit = false,
                        index,
                        arr = this.value.concat();
                    for(let i = 0; i < this.value.length; i++) {
                        if(this.value[i] == val) {
                            index = i
                            isExsit = true
                            break;
                        }
                    }
                    isExsit ? arr.splice(index, 1) : arr.push(val)
                    this.$emit('input', arr)
                }
            },
        },
    }
</script>